import { render, staticRenderFns } from "./ContentViewSettingsPublic.vue?vue&type=template&id=68f0f208&scoped=true&"
import script from "./ContentViewSettingsPublic.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsPublic.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsPublic.vue?vue&type=style&index=0&id=68f0f208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0f208",
  null
  
)

export default component.exports